import { z } from '../params'

// The invocation shapes the runtime hands to the realtime SYSTEM methods (v1-compatible). Runtime-owned,
// not author-declared, and all LOOSE: the flow engine may send fields a given milestone doesn't model yet,
// and dropping them silently would be worse than carrying them through.

const anyRecord = () => z.record(z.string(), z.unknown())

const SubscriptionEventSchema = z.looseObject({
  name: z.string().min(1),
  triggerData: anyRecord().optional(),
})

// upsert + refresh — both subscribe the callback URL for a set of trigger instances.
export const RealtimeSubscriptionInvocationSchema = z.looseObject({
  callbackUrl: z.string().min(1),
  events: z.array(SubscriptionEventSchema).default([]),
  webhookData: anyRecord().nullish(),
  connectionId: z.string().nullish(),
})

// delete — the webhook is torn down from its stored data; the callback URL is informational.
export const RealtimeDeleteInvocationSchema = z.looseObject({
  callbackUrl: z.string().optional(),
  webhookData: anyRecord().nullish(),
  connectionId: z.string().nullish(),
})

// resolve — the raw inbound HTTP delivery.
export const RealtimeInboundInvocationSchema = z.looseObject({
  headers: anyRecord().optional(),
  queryParams: anyRecord().optional(),
  body: z.unknown(),
  rawBody: z.string().optional(),
  connectionId: z.string().nullish(),
})

// select — one resolved event fanned out over the registered trigger instances.
export const RealtimeSelectInvocationSchema = z.looseObject({
  eventName: z.string().min(1),
  eventData: z.unknown(),
  triggers: z.array(z.looseObject({
    id: z.string().min(1),
    // A partially-configured instance is legal — `match` treats an empty param as "matches all".
    data: anyRecord().optional(),
  })).default([]),
})
